module.exports = __webpack_public_path__ + "img/icon.c64b9f39.png";